export const PHOTO_GRADE_CLASS = 'by-photo-grade';

export const photoGradeClassName = (tags?: readonly string[]): string | undefined =>
  tags?.some((tag) => tag.trim().toLowerCase() === 'ungraded') ? undefined : PHOTO_GRADE_CLASS;
